/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { StringParam, useQueryParam } from "use-query-params"
import {
  selectAdasProgramsMetaData,
  selectSensingSystemRequirementsManageDataSourcesDialogOpen,
  selectSensorComponentRequirementsManageDataSourcesDialogOpen,
  selectWorldModelSolutionRequirementsManageDataSourcesDialogOpen,
  setSensingSystemRequirementsManageDataSourcesDialogOpen,
  setSensorComponentRequirementsManageDataSourcesDialogOpen,
  setWorldModelSolutionRequirementsManageDataSourcesDialogOpen
} from "../../../../../../redux/ducks/AdasPrograms/slice"
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks"
import ArgosDialog from "../../../../../components/Dialogs/ArgosDialog"
import { ADAS_DIALOG_STYLE, FilterDatasetsDialog } from "../../../../../components/Tree/Parts/JamaTreeContainer"
import ADAS_PROGRAMS_CONSTANTS from "../../../constants"
import { AdasProgramsReportPageIdx, AdasProgramsReportPages } from "../constants"
import { useMemo } from "react"
import { getPageFromHtabIndex } from "../helpers"


export const manageDataSourcesDialogSlice = {
  [AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT]: {
    isDialogOpen: selectSensingSystemRequirementsManageDataSourcesDialogOpen,
    setIsDialogOpen: setSensingSystemRequirementsManageDataSourcesDialogOpen,
  },
  [AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT]: {
    isDialogOpen: selectSensorComponentRequirementsManageDataSourcesDialogOpen,
    setIsDialogOpen: setSensorComponentRequirementsManageDataSourcesDialogOpen,
  },
  [AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT]: {
    isDialogOpen: selectWorldModelSolutionRequirementsManageDataSourcesDialogOpen,
    setIsDialogOpen: setWorldModelSolutionRequirementsManageDataSourcesDialogOpen,
  },
}

export const ManageDataSourcesDialog = () => {
  const dispatch = useAppDispatch()
  const adasProgramMetaData = useAppSelector(selectAdasProgramsMetaData)
  const isPlanOfRecord = adasProgramMetaData?.isPlanOfRecord

  const htabid = ADAS_PROGRAMS_CONSTANTS.itemDetails.horizontalTabs.pageHtabs.tabIndexUrlKey
  const [htab, setHtab] = useQueryParam(htabid, StringParam)
  const page = useMemo(() => getPageFromHtabIndex(htab as AdasProgramsReportPageIdx), [htab])

  const isOpen = useAppSelector(manageDataSourcesDialogSlice[page].isDialogOpen)
  const onClose = () => {dispatch(manageDataSourcesDialogSlice[page].setIsDialogOpen(false))}

  return (
    <ArgosDialog
      {...ADAS_DIALOG_STYLE}
      open={isOpen}
      onClose={onClose}
      headerTitle={`Manage Data Sources ${isPlanOfRecord ? "(ADAS Program is PoR so only PoR Studies are shown here)" : ""}`}
    >
      <FilterDatasetsDialog page={page} />
    </ArgosDialog>
  )
}
